<template>
    <b-form-row>

        <tarefas-aprovacao-almoxarifado-modal id="modalAprAlmoxarifDetalhe" :isVisualizacao="isVisualizacao"
            v-if="showTarefaAprovacaoAlmoxarifadoModal" :pedido="pedido" :tarefa="selectedItem"
            uri="/aprovacao-almoxarifado" @close="fecharTarefaAprovacaoAlmoxarifado"
            :prefix="prefix + title + ' > '"></tarefas-aprovacao-almoxarifado-modal>

        <tarefas-aprovacao-solicitante-modal id="modalAprSolDetalhe" v-if="showTarefaAprovacaoSolicitanteModal"
            :isVisualizacao="isVisualizacao" :prefix="prefix + title + ' > '" :pedido="pedido" :tarefa="selectedItem"
            uri="/aprovacao-solicitante" @close="fecharTarefaAprovacaoSolicitante">
        </tarefas-aprovacao-solicitante-modal>

        <ModalLogin v-if="showModalLoginModal" @tarefaRetirada="selectedItem = $event"
            @usuarioAutenticado="usuarioAuthenticated = $event" @abrirTarefaRetirada="abrirModalRetirada"
            :tarefa="selectedItem" :prefix="prefix + title + ' > '" @close="showModalLoginModal = false">
        </ModalLogin>

        <TarefaRetiradaModal :prefix="prefix + title + ' > '" :tarefa="selectedItem" :isVisualizacao="isVisualizacao"
            :pedido="this.pedido" uri="/tarefa-retirada" @tarefaRetiradaFinalizado="tarefaRetiradaFinalizado"
            v-if="showTarefaRetiradaModal" @close="tarefaRetiradaFinalizado" :responsavel="usuarioAuthenticated">
        </TarefaRetiradaModal>


        <b-modal id="togglePedidoModal" v-model="showModal" size="xl" :title="prefix + title" @close="closeModal"
            @hidden="closeModal" hide-footer>
            <b-card bg-variant="light">
                <b-card>
                    <div>
                        <span style="font-size: 16px">
                            <strong>Pedido:</strong> {{ pedido.id }}<br />
                            <strong>Solicitante:</strong>
                            {{ pedido.departamentoSolicitante.descricao }} <br />
                            <strong>Status:</strong> {{ pedido.status.descricao }}<br />
                            <strong>Justificativa:</strong> {{ pedido.justificativa }}<br />
                        </span>
                    </div>
                </b-card>

                <b-tabs content-class="mt-3">
                    <b-tab title="Tarefas" active>
                        <b-table id="detalhe-tarefas" responsive class="mt-2" small :items="tarefas"
                            :fields="fieldsTarefas" :busy="this.busy" show-empty>
                            <template v-slot:cell(detalheTarefa)="row">
                                <b-button v-if="row.item.status.id == 129"
                                    v-b-tooltip.hover.bottom="'Detalhes da tarefa...'" size="sm" variant="primary"
                                    @click="detalharTarefa(row.item)" pill>
                                    <b-icon icon="clock" />
                                </b-button>

                                <b-button v-b-tooltip.hover.bottom="'Iniciar a tarefa atual'"
                                    v-if="row.item.status.id === 127 && verificaPrivilegioTarefa(row.item)" pill
                                    size="sm" variant="primary" @click="iniciarTarefa(row.item)">
                                    <b-icon icon="file-earmark-play" />

                                </b-button>
                                <b-button v-if="
                                    row.item.tipoTarefaPedido.id === 10 &&
                                    row.item.status.id !== 127 &&
                                    row.item.status.id !== 129
                                    && verificaPrivilegioTarefa(row.item)
                                " pill size="sm" variant="primary"
                                    v-b-tooltip.hover.bottom="'Continuar a tarefa atual'"
                                    @click=" abrirModalAlmoxarifadoModal(row.item)">
                                    <b-icon icon="file-earmark-bar-graph" />

                                </b-button>

                                <b-button v-if="
                                    (row.item.tipoTarefaPedido.id === 11 ||
                                        row.item.tipoTarefaPedido.id === 13) &&
                                    row.item.status.id !== 127 &&
                                    row.item.status.id !== 129
                                    && verificaPrivilegioTarefa(row.item)
                                " pill size="sm" variant="primary"
                                    v-b-tooltip.hover.bottom="'Continuar a tarefa atual'"
                                    @click="abrirModalSolicitanteModal(row.item)">
                                    <b-icon icon="file-earmark-bar-graph" />

                                </b-button>

                                <b-button v-if="
                                    row.item.tipoTarefaPedido.id === 12 &&
                                    row.item.status.id !== 127 &&
                                    row.item.status.id !== 129
                                    && verificaPrivilegioTarefa(row.item)
                                " pill size="sm" variant="primary"
                                    v-b-tooltip.hover.bottom="'Continuar a tarefa atual'"
                                    @click="abrirModalLogin(row.item)">
                                    <b-icon icon="file-earmark-bar-graph" />

                                </b-button>

                            </template>

                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(pedidoId)>
                                <span>{{ pedido.id }}</span>
                            </template>

                            <template #cell(solicitante)>
                                <span>{{ pedido.departamentoSolicitante.descricao }}</span>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab title="Itens">
                        <b-table id="t-itens" responsive class="mt-2" small :items="itens" :fields="fieldsItens"
                            :busy="this.busy" show-empty>
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab title="Anexos">
                        <b-table id="t-anexos" responsive class="mt-2" small :items="arquivos" :fields="fieldsAnexos"
                            :busy="this.busy" show-empty>
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template #empty>
                                <h6 style="text-align: center">Nenhum arquivo vinculado</h6>
                            </template>

                            <template #cell(nome)="data">
                                <a :href="getFileUrl(data.item.arquivo)" :download="data.item.nome">
                                    {{ data.item.nome }}
                                </a>
                            </template>
                        </b-table>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-modal>
    </b-form-row>

</template>

<script>

import ResourceService from "@/core/api/ResourceService"
import ConfirmMixin from "@/core/mixins/confirm"
import Formatters from "@/core/mixins/formatters"
import Resource from "@/core/mixins/resource"
import moment from "moment"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource"
import TarefasAprovacaoAlmoxarifadoModal from "./TarefasAprovacaoAlmoxarifadoModal.vue"
import TarefasAprovacaoSolicitanteModal from "./TarefasAprovacaoSolicitanteModal.vue"
import TarefaRetiradaModal from "./TarefaRetiradaModal.vue"
import ModalLogin from "./ModalLogin.vue"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import TipoTarefaPedidoEnum from "@/core/utils/TipoTarefaPedidoEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"


export default {
    mixins: [
        Formatters,
        ConfirmMixin,
        Resource.FormResourceMixin,
        ListResourceMixin,
        FormResourceMixin,
    ],
    components: {
        TarefasAprovacaoAlmoxarifadoModal, TarefasAprovacaoSolicitanteModal, TarefaRetiradaModal,
        ModalLogin,
    },

    props: {
        pedido: {
            type: Object,
            required: true,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Detalhes",
        },
    },

    data() {
        return {
            usuarioAuthenticated: {},
            isVisualizacao: false,
            showTarefaAprovacaoSolicitanteModal: false,
            selectedItem: {},
            showTarefaAprovacaoAlmoxarifadoModal: false,
            showModalLoginModal: false,
            showTarefaRetiradaModal: false,
            busy: false,
            showModal: true,
            arquivos: [],
            itens: [],
            tarefas: [],
        }
    },

    beforeMount() {

        this.$service = new ResourceService(`api/pedidos/details/itens`)
        this.$serviceTarefa = new ResourceService(`api/pedidos/details/tarefa`)
        this.$serviceAnexo = new ResourceService(`api/pedidos/details/anexos`)
        this.$serviceTarefaSave = new ResourceService(`/api/tarefaspedido`)


    },

    mounted() {
        this.load()
    },

    computed: {
        fieldsTarefas() {
            return [
                { key: "id", label: "Nº" },
                { key: "pedidoId", label: "Nº Pedido" },
                { key: "status.descricao", label: "Status" },
                { key: "solicitante", label: "Solicitante" },
                { key: "destino", label: "Destino" },
                { key: "pessoa.nome", label: "Responsável" },
                { key: "tipoTarefaPedido.descricao", label: "Tarefa" },
                {
                    key: "dataCriacao",
                    label: "Data",
                    formatter: value => moment(value).format("DD/MM/yyyy HH:mm"),
                },
                { key: "detalheTarefa", label: " " },
            ]
        },

        fieldsItens() {
            return [
                { key: "id", label: "Número" },
                {
                    key: "almoxarifadoProduto.produto.descricaoResumida",
                    label: "Produto",
                },
                {
                    key: "almoxarifadoProduto.almoxarifado.descricao",
                    label: "Almoxarifado",
                },
                { key: "qtdSolicitada", label: "Solicitado" },
                { key: "qtdAprovado", label: "Aprovado" },
                { key: "qtdRetirada", label: "Retirado" },
            ]
        },

        fieldsAnexos() {
            return [{ key: "nome", label: "Arquivo" }]
        },
    },
    methods: {
        verificaPrivilegioTarefa(tarefa) {
            if (parseInt(tarefa.codTipoTarefaPedido) == TipoTarefaPedidoEnum.RETIRADA)
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_ENTREGAR)
            else if (parseInt(tarefa.codTipoTarefaPedido) == TipoTarefaPedidoEnum.APROVACAO_ALMOXARIFADO)
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_APROVACAO);
            else if (parseInt(tarefa.codTipoTarefaPedido) == TipoTarefaPedidoEnum.RECEBIMENTO)
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_RECEBER);
            else
                return verificaPrivilegio(PrivilegiosEnum.PEDIDO_INCLUIR);
        },
        abrirModalLogin(item) {
            this.selectedItem = item
            this.showModalLoginModal = true
        },
        async iniciarTarefa(item) {
            let response = await this.$confirm(
                `Deseja iniciar esta tarefa (${item.tipoTarefaPedido.descricao}) ?`
            )
            if (response) {
                item.status.id = 128
                item.status.descricao = "Em andamento"
                this.$serviceTarefaSave.save(item)
                this.isVisualizacao = false;
                if (item.tipoTarefaPedido.descricao === "Aprovação do Almoxarifado") {
                    this.abrirModalAlmoxarifadoModal(item)
                }
                if (item.tipoTarefaPedido.descricao === "Recebimento") {
                    this.abrirModalSolicitanteModal(item)
                }
                if (item.tipoTarefaPedido.descricao === "Aprovação do Solicitante") {
                    this.abrirModalSolicitanteModal(item)
                }
                if (item.tipoTarefaPedido.descricao === "Retirada") {
                    this.abrirModalLogin(item)
                }
            } else {
                return
            }
        },


        abrirModalRetirada() {
            if (this.usuarioAuthenticated !== null) {
                this.isVisualizacao = false;
                this.showTarefaRetiradaModal = true;

            }
        },

        detalharTarefa(item) {

            this.isVisualizacao = true;
            if (item.tipoTarefaPedido.id == 10) {
                this.abrirModalAlmoxarifadoModal(item);
            }

            if (item.tipoTarefaPedido.id == 12) {
                this.selectedItem = item
                this.showTarefaRetiradaModal = true;
            }

            if (item.tipoTarefaPedido.id == 11 || item.tipoTarefaPedido.id == 13) {
                this.abrirModalSolicitanteModal(item);
            }

        },
        abrirModalSolicitanteModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoSolicitanteModal = true
        },

        abrirModalAlmoxarifadoModal(item) {
            this.selectedItem = item
            this.showTarefaAprovacaoAlmoxarifadoModal = true
        },


        getFileUrl(base64Data) {
            if (!base64Data) return "#"
            return `data:application/octet-stream;base64,${base64Data}`
        },

        async load() {
            this.busy = true


            Promise.all([
                this.$service.findById(this.pedido.id),
                this.$serviceTarefa.findById(this.pedido.id),
                this.$serviceAnexo.findById(this.pedido.id),
            ]).then(response => {
                this.itens = response[0].data
                this.tarefas = response[1].data
                this.arquivos = response[2].data


                this.busy = false
            })
        },


        fecharTarefaAprovacaoAlmoxarifado() {
            this.showTarefaAprovacaoAlmoxarifadoModal = false;
            this.load();
        },

        fecharTarefaAprovacaoSolicitante() {
            this.showTarefaAprovacaoSolicitanteModal = false;
            this.load();
        },


        tarefaRetiradaFinalizado() {
            this.isVisualizacao = false;
            this.showTarefaRetiradaModal = false;
            this.load();
        },

        closeModal() {
            this.$emit("close")
        },
        formatDate(value) {
            return moment(value).format("DD/MM/yyyy")
        },
    },
}
</script>
